import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import functions from './functions';
import cart from "./cart";
import popup from "./popup";
import myAccount from "./my-account";
import accordion from "./accordion-panel";
import carousel from "./carousel";
import sidebar from "./sidebar-list";
import quantity from "./quantity-input";
import header from "./header";
import slider from "./slider";
import video from "./video";
import ingredients from "./ingredients";
import animations from "./animations";
import partnerFinder from "./partner-finder";

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            functions.cookies();
            header.init();
            accordion.init();
            slider.init();
            video.init();
            ingredients.init();
            cart.init();
            myAccount.init();
            quantity.init();
            carousel.relatedProductsCarousel();
            sidebar.init();
            popup.init();
            partnerFinder.init();
            animations.init();
        });
    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();


